import React from 'react'
import { useIntl } from 'react-intl'
import HeadData from 'components/Common/HeadData'

import Travel from './Travel/Travel'
import OurStory from './OurStory/OurStory'
import WorkWithUs from './WorkWithUs/WorkWithUs'
import config from 'constants/config'
import ImageHero from 'components/Common/ImageHero'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import styled from 'styled-components'
import WhyBookWithUsSection from './WhyBookWithUs/WhyBookWithUsSection'
import Reviews from 'components/Pages/AboutUsPage/Reviews/Reviews'
import PartnerBrands from 'components/Common/PartnerBrands/PartnerBrands'

const HeroImage = styled(ImageHero)`
  max-height: ${rem(470)};
`

function AboutUsPage() {
  const intl = useIntl()
  const showPartnerLogos = config.logoImages && config.logoImages.length > 0

  const pageTitle = intl.formatMessage(
    {
      id: 'QkRU+QX6Vx',
      defaultMessage: 'About Us - {siteTitle}',
      description: 'About Us page title with site name on the about us page',
    },
    { siteTitle: config.title },
  )

  const pageDescription = intl.formatMessage({
    id: '7wSRWtiWch',
    defaultMessage: 'Information about the company, Leadership and culture',
    description: 'About Us page meta description on the about us page',
  })

  const heroImageAlt = intl.formatMessage({
    id: '086SvcFm4u',
    defaultMessage: 'About us header image',
    description: 'Accessibility alt text for About Us hero image on the about us page',
  })

  const heroHeading = intl.formatMessage({
    id: 'en1l0GSS6/',
    defaultMessage: 'The world’s best escapes, handpicked by experts',
    description: 'Hero section heading for the About Us page describing handpicked travel escapes',
  })

  const heroBody = intl.formatMessage({
    id: 'mdNCf9AbeB',
    defaultMessage: 'At Luxury Escapes we believe everyone should travel in style. That’s why we offer the world’s most amazing travel experiences at great prices.',
    description: 'About Us hero section body text on the experience offer or booking page',
  })

  return (
    <>
      <HeadData
        title={pageTitle}
        description={pageDescription}
      />
      <HeroImage
        alt={heroImageAlt}
        id="about-us-image"
      >
        <LayoutContainer>
          <Heading variant="heading2" align="center" colour="neutral-eight">
            {heroHeading}
          </Heading>
          <BodyText variant="large" align="center" colour="neutral-eight">
            {heroBody}
          </BodyText>
        </LayoutContainer>
      </HeroImage>
      <OurStory />
      <WhyBookWithUsSection />
      <Travel />
      <Reviews />
      {showPartnerLogos && <PartnerBrands />}
      <WorkWithUs />
    </>
  )
}

export default AboutUsPage
